function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.895431 0.895431 0 2 0H38C39.1046 0 40 0.895431 40 2V38C40 39.1046 39.1046 40 38 40H2C0.895431 40 0 39.1046 0 38V2Z",
  fill: "#A4D65E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.728 27.2942L25.8332 23.3994C25.6574 23.2236 25.4191 23.126 25.1691 23.126H24.5323C25.6105 21.747 26.2512 20.0125 26.2512 18.1256C26.2512 13.637 22.6142 10 18.1256 10C13.637 10 10 13.637 10 18.1256C10 22.6142 13.637 26.2512 18.1256 26.2512C20.0125 26.2512 21.747 25.6105 23.126 24.5323V25.1691C23.126 25.4191 23.2236 25.6574 23.3994 25.8332L27.2942 29.728C27.6614 30.0952 28.2552 30.0952 28.6185 29.728L29.7241 28.6225C30.0913 28.2552 30.0913 27.6614 29.728 27.2942ZM18.1256 23.126C15.3637 23.126 13.1252 20.8914 13.1252 18.1256C13.1252 15.3637 15.3598 13.1252 18.1256 13.1252C20.8875 13.1252 23.126 15.3598 23.126 18.1256C23.126 20.8875 20.8914 23.126 18.1256 23.126Z",
  fill: "black"
});

var SvgSearchBtn = function SvgSearchBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SearchBtn.bd2feb36.svg";
export { ForwardRef as ReactComponent };